import { Component, HostListener, inject } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { LayoutComponent } from '../../core/layout/layout.component';
import { MatInputModule } from '@angular/material/input';
import {
  MatDialog,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { AgGridAngular } from 'ag-grid-angular';
import { ColDef } from 'ag-grid-community';
import { Router } from '@angular/router';
// import { PaymentsItemService } from '../../features/payments/services/payments.service';
import { PaginationHelper } from '../../shared/services/pagination.service';
import { Subject, debounceTime, distinctUntilChanged } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { PAYMENT_MODES } from '../../helpers/helper-file';
import { PaymentsService } from '../../features/payments/services/payments.service';
import { PaymentMethodsEnum } from '../../../assets/enum/paymentMethodsEnum';
import { FormsModule } from '@angular/forms';
import { ModuleIds } from '../../shared/permission-constants/permission-const';
import { PermissionService } from '../../shared/services/permission.service';
// import { PermissionDirective } from '../../shared/directives/permissions.directive';
// import { Permission } from '../../shared/services/permissions';

@Component({
  selector: 'app-payments-made',
  standalone: true,
  imports: [CommonModule, LayoutComponent, MatInputModule, AgGridAngular,FormsModule],
  templateUrl: './payments-made.component.html',
  styleUrl: './payments-made.component.scss',
})
export class PaymentsMadeComponent {
  public viewPortSize: boolean = false;
  public defaultColDef: ColDef = {
    filter: 'agTextColumnFilter',
    floatingFilter: true,
  };
  public rowSelection: 'single' | 'multiple' = 'multiple';
  public paginationPageSize = 10;
  public paginationPageSizeSelector: number[] | boolean = [10, 25, 50];
  public themeClass: string = 'ag-theme-quartz';
  public rowData: any[] = [];
  private searchSubject = new Subject<string>();
  paymentModeList: any;
  selectedModes: string[] = [];
  selectedCount: number = 0;
  // columnDefs: { headerName: string; field: string; flex: number; cellRenderer?: undefined;}[];
  columnDefs: ({ headerName: string; field: string; flex: number; cellRenderer?: undefined; floatingFilter?: undefined; filter?: undefined; } | { headerName: string; field: string; flex: number; cellRenderer: (params: any) => string; floatingFilter?: undefined; filter?: undefined; } | { field: string; headerName: string; flex: number; cellRenderer: (params: any) => HTMLDivElement; floatingFilter: boolean; filter: boolean; })[];
  page = 0;
  pageSize = 10;
  totalPages = 1;
  pageSizeOptions = [5, 10, 20, 50, 100];
  search: any;
  startDate: any;
  endDate: any;
  canAddPayment$ = this.permissionService.hasPermission(
    ModuleIds.PaymentMade,
    'Create'
  );
  canEditPayment$ = this.permissionService.hasPermission(
    ModuleIds.PaymentMade,
    'Edit'
  );

  canEditPayment: boolean = false;

  constructor(
    private router: Router,
    private itemService: PaymentsService,
    private datePipe: DatePipe,
    private permissionService: PermissionService
  ) { }

  ngOnInit(): void {
    this.fetchItems();
    this.loadPaymentMethods();
    this.searchSubject
      .pipe(debounceTime(600), distinctUntilChanged())
      .subscribe((searchTerm) => {
        this.search = searchTerm;
        this.fetchItems();
      });

      this.canEditPayment$.subscribe((canEditPayment) => {
        this.canEditPayment = canEditPayment;
      })
    this.checkViewportSize();
  }

  navigateTo(route: string) {
    this.router.navigate([route]);
  }

  readonly dialog = inject(MatDialog);

  // openDialog() {
  //   const dialogRef = this.dialog.open(UploadPaymentsMadeDialog);
  //   dialogRef.afterClosed().subscribe((result) => {
  //     if (result === 'refresh') {
  //       this.fetchItems();
  //     }
  //   });
  // }

  onCellClicked(params: any) {
    // this.router.navigate([`payments-made/payments-made-details`]);
    if (
      params.column.colId === 'action' &&
      params.event.target.dataset.action
    ) {
      let action = params.event.target.dataset.action;

      if (action === 'edit') {
        this.openEdit(params?.data);
      } 
      // else if (action === 'delete') {
      //   this.onDeleteJournal(params?.data);
      // }
    } else {
    const id = params.data?.id;
    this.router.navigate([`payments-made/payments-made-details`], {
      queryParams: { id: id },
    });
  }
  }

  openEdit(journalData: any) {
    const journalId = journalData?.id;
    if (journalId) {
      this.router.navigate([`/payments-made/update-bill-payment/${journalId}`]);
    }
  }

  isDropdownOpen = false;

  toggleDropdown(event?: MouseEvent) {
    if (event) {
      event.stopPropagation();
    }
    this.isDropdownOpen = !this.isDropdownOpen;
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.checkViewportSize();
  }

  checkViewportSize() {
    if (window.innerWidth > 1200) {
      this.viewPortSize = true;
    } else {
      this.viewPortSize = false;
    }
    this.setAGColumn();
  }

  private loadPaymentMethods() {
      this.paymentModeList = Object.values(PaymentMethodsEnum).map((type) => ({
        label: type.label,
        value: type.value,
      }));
    }

  setAGColumn() {

    this.columnDefs = [
      {
        headerName: 'Date',
        field: 'data',
        flex: this.viewPortSize ? 1 : 0,
      },
      { headerName: 'Payment Code', field: 'paymentNo', flex: this.viewPortSize ? 1 : 0 },
      { headerName: 'Reference No', field: 'referenceNo', flex: this.viewPortSize ? 1 : 0 },
      { headerName: 'Customer Name', field: 'name', flex: this.viewPortSize ? 1 : 0 },
      { headerName: 'Vendor Invoice', field: 'invoice', flex: this.viewPortSize ? 1 : 0 },
      { headerName: 'Mode', field: 'mode', flex: this.viewPortSize ? 1 : 0 },
      { headerName: 'Payment Status', field: 'paymentStatus', flex: this.viewPortSize ? 1 : 0 ,
        cellRenderer: (params: any) => {
          const paymentStatus = params.data?.paymentStatus;
          return paymentStatus === 'Pending' ? `<span style="color: orange;">${paymentStatus}</span>` :paymentStatus === 'Cancelled' ? `<span style="color: red;">${paymentStatus}</span>` : `<span style="color: green;">${paymentStatus}</span>`;
      }
      },
      { headerName: 'Amount', field: 'amount', flex: this.viewPortSize ? 1 : 0,
        cellRenderer: (params: any) => {
          const amount = parseFloat(params.data?.amount) || 0; // Ensure 0 for null/undefined/NaN values
          return `<span>AED ${amount.toFixed(2)}</span>`;
      }
     },
     {
      field: 'action',
      headerName: 'Actions',
      flex: this.viewPortSize ? 1 : 0,
      cellRenderer: (params: any) => {
        const container = document.createElement('div');
        container.style.display = 'flex';
        container.style.alignItems = 'center';
        container.style.gap = '20px';

        const editIcon = document.createElement('img');
        editIcon.src = 'assets/images/icons/icon-edit.svg';
        editIcon.style.cursor = 'pointer';
        editIcon.setAttribute('data-action', 'edit');

        // const deleteIcon = document.createElement('img');
        // deleteIcon.src = 'assets/images/icons/icon-delete.svg';
        // deleteIcon.style.cursor = 'pointer';
        // deleteIcon.setAttribute('data-action', 'delete');
        if(params.data?.paymentStatus==='Pending'){
          if(this.canEditPayment){
            container.appendChild(editIcon);
          }
        }
        // if(this.profileName === 'admin'){
        // container.appendChild(deleteIcon);
        // }

        // this.store.select(selectPermissions.hasPermission('31', Permission.Edit)).subscribe((canEdit) => {
        // });
      // this.store.select(selectPermissions.hasPermission('31', Permission.Delete)).subscribe((canDelete) => {
      //     if (canDelete) {
            // container.appendChild(deleteIcon);            
          // }
        // });
        return container;
      },
      floatingFilter: false,
      filter: false,
    },
    ];
  }

  onSearch(event: Event) {
    const input = event.target as HTMLInputElement;
    const searchTerm = input.value;
    this.searchSubject.next(searchTerm);
  }

  fetchItems(pageSize: number = 10) {
    if (pageSize) {
      this.pageSize = pageSize;
    }
    const filter={  
      paymentType:'Bills',
      paymentMethod:this.selectedModes
      
    }
    // console.log("delectdmodes",this.selectedModes);
    const skip = this.page * this.pageSize;
    const input = {
      search: this.search,
      limit: this.pageSize,
      filter:filter,
      // advancedSearch: this.advancedSearch,
      // startDate:this.startDate,
      // endDate: this.endDate,
      skip,
    }
    this.itemService.findAllPaymentsWithPagination(input).subscribe({
      next: (payments) => {
        this.totalPages = Math.ceil(
          (payments?.total || payments?.payments?.length) / this.pageSize
        );   
        // console.log("hedjnsduhfe",payments);
        // console.log("rowdata",payments?.payments);
        this.rowData = (payments?.payments || []).map((payment: any) => {
          return {
            id: payment?.id,
            data:
              this.datePipe.transform(payment?.paymentDate, 'dd/MM/YYYY') || '--',
            paymentNo: payment?.paymentCode || '--',
            referenceNo: payment?.referenceNo || '--',
            name: payment?.vendorData?.vendorName || '--',
            invoice: payment?.paymentInfo?.[0]?.bill?.billNo || '--',
            mode: payment?.paymentMethod || '--',
            paymentStatus: payment?.paymentStatus || '--',
            amount: payment?.amount || '--',
          };
        });
        // Update pagination options based on the rowData length
        // this.paginationPageSizeSelector =
        //   PaginationHelper.getPaginationPageSizeOptions(this.rowData);
      },
    });
  }

  nextPage() {
    if (this.page + 1 < this.totalPages) {
      this.page++;
      this.fetchItems(this.pageSize);
    }
  }

  prevPage() {
    if (this.page > 0) {
      this.page--;
      this.fetchItems(this.pageSize);
    }
  }

  onPageSizeChange(event: Event): void {
    const newSize = Number((event.target as HTMLSelectElement).value);
    console.log('New Page Size:', newSize);
    this.pageSize = newSize; // ✅ Correctly update pageSize
    this.page = 0; // ✅ Reset to first page
    this.fetchItems(this.pageSize); // ✅ Use new pageSize
  }

  onApplyFilters() {
    this.fetchItems();
    this.toggleDropdown();
  }

  toggleMode(mode: string) {
    if (this.selectedModes.includes(mode)) {
      this.selectedModes = this.selectedModes.filter((m) => m !== mode);
    } else {
      this.selectedModes.push(mode);
    }
    this.selectedCount = this.selectedModes?.length;
  }

  clearFilters() {
    this.selectedModes = [];
    this.fetchItems();
    this.toggleDropdown();
    this.selectedCount = 0;
  }
}

// @Component({
//   selector: 'upload-payments-made-dialog',
//   templateUrl: 'upload-payments-made-dialog.html',
//   styleUrls: ['./payments-made.component.scss'],
//   standalone: true,
//   imports: [CommonModule, MatDialogModule, MatButtonModule],
// })
// export class UploadPaymentsMadeDialog {
//   file: any = null;
//   url: any = null;

//   constructor(
//     private toastr: ToastrService,
//     // private itemService: PaymentsItemService,
//     private dialogRef: MatDialogRef<UploadPaymentsMadeDialog>
//   ) { }

//   ngOnInit() {
//     document.addEventListener('dragover', this.preventDefaultBehavior);
//     document.addEventListener('drop', this.preventDefaultBehavior);
//   }

//   preventDefaultBehavior(event: DragEvent) {
//     event.preventDefault();
//   }

//   onDragOver(event: DragEvent) {
//     event.preventDefault();
//   }

//   onDrop(event: DragEvent) {
//     event.preventDefault();

//     if (event.dataTransfer?.files.length) {
//       this.onFileSelected({ target: { files: event.dataTransfer.files } });
//     }
//   }

//   onFileSelected(event: any): void {
//     const input = event.target as HTMLInputElement;
//     if (input.files && input.files.length > 0) {
//       const file = input.files[0];
//       this.file = file;
//     }
//   }

//   uploadDocuments(csvFile: any) {
//     // this.itemService.bulkCreatePayment(csvFile).subscribe({
//     //   next: (response) => {
//     //     if (response == true) {
//     //       this.toastr.success('Bulk updated successfully!');
//     //       this.dialogRef.close('refresh');
//     //     }
//     //   },
//     //   error: (error) => {
//     //     this.toastr.error(error.message, 'Bulk updated failed');
//     //     this.dialogRef.close();
//     //   },
//     // });
//   }

//   removeFile(): void {
//     this.file = null;
//     const input = document.querySelector(
//       'input[type="file"]'
//     ) as HTMLInputElement;
//     if (input) {
//       input.value = '';
//     }
//   }

//   onUpload() {
//     this.uploadDocuments(this.file);
//   }

//   ngOnDestroy() {
//     document.removeEventListener('dragover', this.preventDefaultBehavior);
//     document.removeEventListener('drop', this.preventDefaultBehavior);
//   }
// }
